<template>
  <div class="waiting-payment-modular">
    <MyHeader></MyHeader>
    <ShareRight></ShareRight>

    <div class="header-menu-bar-modular">
      <!-- <div class="menu-bar">
        <div
          class="menu-bar-item"
          v-for="(item, index) in menuBar"
          :key="index"
        >
          <span class="top-bar-title" @click="toPersonCenter(index)">{{currLanguage==3?item.eng_title:item.title}}</span>
          <img
            class="top-bar-icon"
            v-if="index < menuBar.length - 1"
            src="../assets/productDetail/top-bar-icon.png"
            alt=""
          />
        </div>
      </div> -->
      <div class="menu-bar">
        <div
          class="menu-bar-item"
        >
        
          <span class="top-bar-title" @click="toPersonCenter(0)">{{ pageTextArr[0] }}</span>
          <img
            class="top-bar-icon"
           
            src="../assets/productDetail/top-bar-icon.png"
            alt=""
          />
          <span class="top-bar-title" @click="toPersonCenter(1)">{{ pageTextArr[1] }}</span>
          <img
            class="top-bar-icon"
          
            src="../assets/productDetail/top-bar-icon.png"
            alt=""
          />
          <span class="top-bar-title" @click="toPersonCenter(1)">{{ pageTextArr[2] }}</span>
          
        </div>
      </div>
    </div>
    <div class="waiting-payment-body-modular">
      <div class="waiting-payment-item waiting-payment-item-1">
        <el-row>
          <el-col :span="6" :xs="24">
            <div class="waiting-payment-item-left">
              <div class="order-detail-item-modular">
                <div class="order-detail-num-title">
                  {{currLanguage==3?"Order number:":pageTextArr[3]}}{{ orderInfo.order_number }}
                </div>
                <div class="waiting-payment-title">
                  <span v-if="orderInfo.status == -1">{{ pageTextArr[5] }}</span>
                  <span v-if="orderInfo.status == 1">{{ pageTextArr[4] }}</span>
                  <span
                    v-else-if="orderInfo.status == 2 || orderInfo.status == 3"
                    >{{ pageTextArr[6] }}</span
                  >
                  <span v-else-if="orderInfo.status == 4">{{ pageTextArr[7] }}</span>
                  <span v-else-if="orderInfo.status == 5">{{ pageTextArr[8] }}</span>
                </div>
                <div v-if="orderInfo.status == 1">
                  <div class="waiting-payment-surplus-time">
                    <van-count-down
                      :time="countdownTime"
                      format=" HH：mm ：ss"
                    />
                  </div>
                  <el-button class="payment-btn" @click="orderPay()"
                    >{{ pageTextArr[9] }}</el-button
                  >
                </div>
                <div v-else-if="orderInfo.status == 4">
                  <el-button
                    class="payment-btn"
                    @click="dealOrder(orderInfo.id, 5)"
                    >{{ pageTextArr[10] }}</el-button
                  >
                </div>
                <div v-else-if="orderInfo.status == 5">
                  <!-- <el-button class="payment-btn">确认收货</el-button> -->
                </div>
                <div v-else-if="orderInfo.status == 6">
                  <el-button class="payment-btn">{{ pageTextArr[11] }}</el-button>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="18" :xs="24">
            <div class="waiting-payment-item-right">
              <div class="waiting-payment-steps-title">
                <span v-if="orderInfo.status == 1">
                  {{ currLanguage==3?"":pageTextArr[12] }}<van-count-down
                    :time="countdownTime"
                    format=" HH：mm：ss"
                  />{{ pageTextArr[13] }}
                </span>
                <span v-else-if="orderInfo.status == 3">
                  {{ pageTextArr[14] }}
                </span>
                <span v-else-if="orderInfo.status == 4">
                  {{ pageTextArr[39] }}
                </span>
                <span v-else-if="orderInfo.status == 5">
                  {{ pageTextArr[40] }}
                </span>
              </div>
              <div class="steps-modular">
                <!-- 步骤 -->
                <el-steps
                  align-center
                  :active="waitingPayment.activeSteps"
                  finish-status="danger"
                >
                  <el-step
                    :class="
                      index < waitingPayment.activeSteps
                        ? 'stepActive'
                        : 'stepNoActive'
                    "
                    :title="currLanguage==3?item.eng_title:item.title"
                    :description="
                      index <= waitingPayment.activeSteps ? item.time : ''
                    "
                    v-for="(item, index) in waitingPayment.stepsData"
                    :key="index"
                  ></el-step>
                </el-steps>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 运输方式，物流信息 -->
      <!-- <div class="waiting-payment-item waiting-payment-item-2">
                      <el-row>
                        <el-col :span="6" :xs="24" style="max-height: 300px;">
                          <div class="waiting-payment-item-left">
                            <div class="transport-type-modular">
                              <div class="transport-type-title">
                                运输方式：{{ waitingPayment.logistics.transportType }}
                              </div>
                              <div class="transport-type-mobile">
                                电话：{{ waitingPayment.logistics.mobile }}
                              </div>
                              <div class="transport-type-courier-number">
                                快递单号：{{ waitingPayment.logistics.courierNumber }}
                              </div>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="18" :xs="24">
                          <div class="waiting-payment-item-right">
                            <div class="transport-status-modular">
                              <div class="transport-time-item">
                                {{ waitingPayment.logistics.placeOrderTime }}
                              </div>
                              <div class="transport-time-line-item">
                                <el-timeline>
                                  <el-timeline-item v-for="(activity, index) in waitingPayment.timelineData" :key="index"
                                    :icon="activity.icon" :type="activity.type" :color="activity.color" size="large"
                                    :timestamp="activity.timestamp" placement="top">
                                    <h4 v-if="activity.content != null">{{ activity.content }}</h4>
                                    <p v-iif="activity.info != null">{{ activity.info }}</p>
                                  </el-timeline-item>
                                </el-timeline>
                              </div>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div> -->
      <div class="waiting-payment-item waiting-payment-item-3">
        <el-row>
          <el-col :span="12" :xs="24">
            <div class="waiting-payment-item-left">
              <div class="consignee-detail-info-modular">
                <div class="consignee-header-title">{{ pageTextArr[15] }}--{{ method_type==2?pageTextArr[38]:"" }}</div>
                <div class="consignee-name">
                 {{pageTextArr[16]}} {{ consigneeInfo.recivername }}
                </div>
                <div class="consignee-address">
                  {{pageTextArr[17]}} {{currLanguage==1?
                    consigneeInfo.country +" "+
                    consigneeInfo.province +
                    consigneeInfo.city +
                    consigneeInfo.area +
                    consigneeInfo.address:consigneeInfo.eng_country+" "+consigneeInfo.address
                  }}
                </div>
                <div class="consignee-phone">
                  {{pageTextArr[18]}} {{ consigneeInfo.mobile }}
                </div>
                <div class="consignee-phone">
                  {{pageTextArr[41]}} {{ orderInfo.expresscode }}
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12" :xs="24">
            <div class="waiting-payment-item-right">
              <div class="payment-detail-info-modular">
                <div class="payment-header-title">{{pageTextArr[19]}}</div>
                <div class="payment-type">
                  {{pageTextArr[20]}} {{ orderInfo.payment_name }}
                </div>
                <div class="payment-time">
                  {{pageTextArr[21]}} {{ orderInfo.paytime }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="waiting-payment-item waiting-payment-item-4">
        <table class="product-info-table">
          <thead class="product-info-thead">
            <td class="product-detail-info-td">{{pageTextArr[22]}}</td>
            <td>{{pageTextArr[23]}}</td>
            <td>{{pageTextArr[24]}}</td>
            <td>{{pageTextArr[25]}}</td>
          </thead>
          <tbody
            class="product-info-tbody"
            v-for="(item, indx) in productInfo"
            :key="index"
          >
            <!-- 组合 productType==1-->
            <tr v-if="item.productType == 1" valign="top">
              <td class="product-detail-info-td">
                <div class="product-img-item">
                  <img class="product-img" :src="item.cover" alt="" />
                </div>
                <div class="product-info-item">
                  <div class="product-detail-info">{{ currLanguage==3?item.eng_title:item.title }}</div>
                  <div class="product-detail-voltage">
                    {{ currLanguage==3?item.eng_specifications:item.specifications }}
                  </div>
                </div>
              </td>
              <td valign="top">{{ currencySymbol }}{{ item.actual_price }}</td>
              <td valign="top">{{ item.amount }}</td>
              <td class="product-payment-status-td" valign="top">
                <span v-if="orderInfo.status == -1">{{$t("translateText.cancelorderText")}}</span>
                <span v-if="orderInfo.status == 1">{{$t("translateText.baidText")}}</span>
                <span v-if="orderInfo.status == 2">{{$t("translateText.reviewedText")}}</span>
                <span v-if="orderInfo.status == 3">{{$t("translateText.PaidText")}}</span>
                <span v-if="orderInfo.status == 4">{{$t("translateText.receivedText")}}</span>
                <span v-if="orderInfo.status == 5">{{$t("translateText.signedforText")}}</span>
                <span v-if="orderInfo.status == 6">{{$t("translateText.rejectionText")}}</span>
                <span v-if="orderInfo.status == 7">{{$t("translateText.evaluated1Text")}}</span>
              </td>
            </tr>
            <!-- 单品 productType==0-->
            <tr v-if="item.productType == 0">
              <td class="product-detail-info-td">
                <div class="product-img-item">
                  <img class="product-img" :src="item.cover" alt="" />
                </div>
                <div class="product-info-item">
                  <div class="product-detail-info">{{ currLanguage==3?item.eng_title:item.title }}</div>
                  <div class="product-detail-voltage">
                    {{ currLanguage==3?item.eng_specifications:item.specifications }}
                  </div>
                </div>
              </td>
              <td valign="top">
                  {{ currencySymbol }}{{ item.actual_price }}
              </td>
              <td valign="top">{{ item.amount }}</td>
              <td class="product-payment-status-td" valign="top">
                <span v-if="orderInfo.status == -1">{{pageTextArr[5]}}</span>
                <span v-if="orderInfo.status == 1">{{pageTextArr[4]}}</span>
                <span v-if="orderInfo.status == 2">{{pageTextArr[26]}}</span>
                <span v-if="orderInfo.status == 3">{{pageTextArr[27]}}</span>
                <span v-if="orderInfo.status == 4">{{pageTextArr[7]}}</span>
                <span v-if="orderInfo.status == 5">{{pageTextArr[8]}}</span>
                <span v-if="orderInfo.status == 6">{{pageTextArr[28]}}</span>
                <span v-if="orderInfo.status == 7">{{pageTextArr[29]}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="product-total-price-modualr">
          <div class="product-total-info-item">
            <span class="product-total-num">{{ orderInfo.product_num }}</span>
            <span class="item-title-span">{{pageTextArr[30]}}&nbsp;&nbsp;{{pageTextArr[31]}}</span>
            <span class="product-total-price money-item-span">{{
              currencySymbol + orderInfo.totalprice
            }}</span>
          </div>
          <div class="product-total-info-item">
            <span class="item-title-span">{{pageTextArr[32]}}</span>
            <span class="money-item-span">{{
              currencySymbol + orderInfo.expressprice
            }}</span>
          </div>
          <div class="product-total-info-item">
            <span class="item-title-span">{{pageTextArr[33]}}</span>
            <span class="money-item-span">{{
              currencySymbol + orderInfo.tax_price
            }}</span>
          </div>
          <div class="product-total-info-item">
            <span class="item-title-span">{{pageTextArr[35]}}</span>
            <span class="money-item-span">{{
              currencySymbol + orderInfo.discount_price
            }}</span>
          </div>
          <div class="product-total-info-item" v-if="orderInfo.coupon_price">
            <span class="item-title-span">{{pageTextArr[34]+":"}}</span>
            <span class="money-item-span"
              >-{{
                currencySymbol +
                (orderInfo.coupon_price == "" ||
                orderInfo.coupon_price == null ||
                orderInfo.coupon_price == "null"
                  ? ""
                  : orderInfo.coupon_price)
              }}</span
            >
          </div>
          <div class="product-total-amount-payable-item">
            <span class="item-title-span">{{pageTextArr[36]}}</span>
            <span class="money-item-span">{{
              currencySymbol +
              (orderInfo.endprice == "" ||
              orderInfo.endprice == null ||
              orderInfo.endprice == "null"
                ? ""
                : orderInfo.endprice)
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
export default {
  data() {
    return {
      currLanguage: "",
      productPayloading: "", //支付loading
      currencySymbol:
        localStorage.getItem("currencySymbol") == null
          ? "$"
          : localStorage.getItem("currencySymbol"),
      order_id: "",
      order_number: "",
      countdownTime: ref(20 * 60 * 1000),
      currTime: "", //当前时间
      currencySymbol: localStorage.getItem("currencySymbol"),
      method_type:"",
      menuBar: [
        { title: "首页", eng_title: "Home" },
        { title: "个人中心", eng_title: "Personal Center" },
        { title: "我的订单", eng_title: "My Order" },
      ],
      // 代付款信息
      waitingPayment: {
        activeSteps: 0,
        paymentType: 3, //0-等待付款，1-待发货，2-待收货，3-已收货，4-已评价
        stepsData: [
          //步骤条
          {
            title: "提交订单",
            eng_title:"Place order",
            time: "",
          },
          {
            title: "付款成功",
            eng_title:"Payment succeeded",
            time: "",
          },
          {
            title: "商家发货",
            eng_title:"Merchant shipments",
            time: "",
          },
          {
            title: "确认收货",
            eng_title:"Confirm receipt",
            time: "",
          },
          {
            title: "评价",
            eng_title:"Appraise",
            time: "",
          },
        ],
        // 运输方式
        logistics: {
          transportType: "德邦物流",
          mobile: "95353",
          courierNumber: "db37200006162002", //快递单号
          placeOrderTime: "2022-12-16    09:09:45", //下单时间
        },
        timelineData: [
          {
            content: "已下单",
            info: "您提交了订单。",
            timestamp: "2018-04-12 20:46",
            size: "large",
            type: "primary",
            icon: "el-icon-check",
            color: "#EC0000",
          },
          {
            content: "出库",
            info: "",
            timestamp: "2018-04-03 20:46",
          },
          {
            content: "运输中",
            info: "",
            timestamp: "2018-04-03 20:46",
            size: "large",
          },
          {
            content: "",
            info: "[泰安市转运中心公司]已发出",
            timestamp: "2018-04-03 20:46",
          },
          {
            content: "",
            info: "[泰安市转运中心公司]已收入",
            timestamp: "2018-04-03 20:46",
          },
          {
            content: "派送中",
            info: "[苏州吴中区车坊镇经营分部]派件员：薛向阳 电话：16626332235 ，派送中，德邦已开启”安全呼叫“，保护您的电话隐私,如有疑问，请联系：0512-51939188",
            timestamp: "2018-04-03 20:46",
          },
        ],
      },
      // 收货人信息
      consigneeInfo: {
        userName: "陈朋朋",
        address: "江苏南通市海安市城东镇黄海大道58号星湖湾52-1602",
        phone: "18835677644",
      },
      // 付款信息
      paymentInfo: {
        paymentType: "支付宝支付",
        paymentTime: "022-12-16    09:09:45",
      },
      // 产品信息
      productInfo: [],
      // 订单信息
      orderInfo: [],
      pageTextArr:[
        "首页",
        "个人中心",
        "我的订单",
        "订单号：",
        "等待付款",
        "取消订单",
        "待发货",
        "待收货",
        "已签收",
        "付款",
        "确认收货",
        "评价",
        "您还有",
        "来付款，超时订单自动关闭",
        "尊敬的客户，您的订单正在出库，请您耐心等待。",
        "收货人信息",
        "收货人：",
        "所在地址：",
        "手机：",
        "付款信息",
        "付款方式：",
        "付款时间：",
        "产品信息",
        "单价",
        "数量",
        "交易状态",
        "待审核",
        "待支付",
        "拒收",
        "已评价",
        "商品数量",
        "合计：",
        "运费：",
        "税费：",
        "优惠券",
        "满减金额：",
        "应付金额：",
        "正在支付中",
        "自提",
        "商家已发货，等待您的确认收货",
        "订单已经完成，感谢您在锦格购物，欢迎您对本次交易及所购商品进行评价。",
        "快递单号："
      ],
    };
  },
  methods: {
    /**
     * 订单详情
     */
    getUserOrderDetail() {
      let that = this;
      let data = {
        order_number: that.order_number,
        exchange_rate: localStorage.getItem("currencyRate"),
      };
      this.$http.getUserOrderDetail(
        data,
        (res) => {
          if (res.ret == 1) {
            // 设置步骤条状态
            that.setStepByOrder(res.data.log);
            // 收货人信息
            that.consigneeInfo = res.data.address.data[0];
            // 产品信息
            that.productInfo = []; //= res.data.product_data;
            //
            if (res.data.product_data.length != 0) {
              // 单个商品
              res.data.product_data.forEach((v, i) => {
                v.productType = 0;
                that.productInfo.push(v);
              });
            }
            if (res.data.portfolio_sales_data.length != 0) {
              // 组合商品
              res.data.portfolio_sales_data.forEach((v, i) => {
                v.forEach((v2, i2) => {
                  v2.productType = 1;
                  that.productInfo.push(v2);
                });
              });
            }
            if(that.productInfo.length>0 && this.currLanguage!=3 && this.currLanguage!=1){
              that.languageTranslateByArrs(that.productInfo,3);

            }
            // 订单信息
            that.orderInfo = res.data[0];
            that.method_type=res.data[0].method_type;
            // 计算倒计时
            that.getCountdownByOrder();
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 设置步骤调
     * @param {*} stepData
     */
    setStepByOrder(stepData) {
      let that = this;
      that.waitingPayment.activeSteps = stepData.length - 1;
      stepData.forEach((v, i) => {
        that.waitingPayment.stepsData[i].time = stepData[i].create_time;
      });
      // //提交订单
      // that.waitingPayment.stepsData[0].time = stepData[0].create_time;
      // //付款成功
      // that.waitingPayment.stepsData[1].time = stepData[1].create_time;
      // //商家发货
      // that.waitingPayment.stepsData[2].time = stepData[2].create_time;
      // //确认收货
      // that.waitingPayment.stepsData[3].time = stepData[3].create_time;
      // //评价
      // that.waitingPayment.stepsData[4].time = stepData[4].create_time;
    },

    /**
     * 获取倒计时
     */
    getCountdownByOrder() {
      let that = this;
      let startTime = that.currTime;
      let entTime = that.orderInfo.expire_time;
      that.countdownTime =
        this.$moment(entTime).valueOf() - this.$moment(startTime).valueOf();
    },

    /**
     * 当前时间
     */
    getTime() {
      var _this = this;
      let yy = new Date().getFullYear();
      var mm =
        new Date().getMonth() > 9
          ? new Date().getMonth() + 1
          : new Date().getMonth() == 9
          ? new Date().getMonth() + 1
          : "0" + (new Date().getMonth() + 1);
      var dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      let hh = new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      _this.currTime =
        yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
    },

    /**
     * 支付
     */
    orderPay() {
      let that = this;
      let data = {
        order_id: that.order_id, //
        order_number: that.orderInfo.order_number, //订单编号
        money: that.orderInfo.endprice, //支付金额
        currency: localStorage.getItem("currencyName"), // USD 默认美元
        exchange_rate: localStorage.getItem("currencyRate"),
      };
      that.payLoading();
      // orderPay testPay
      this.$http.orderPay(
        data,
        (res) => {
          if (res.ret == 1) {
            if(that.orderInfo.payment_id==1){
              const newWindow = window.open('', '_self');
              newWindow.document.write(res.approval_url);
              newWindow.focus();
            }else{
            location.href = res.approval_url;

            }

            // let payUrl = window.open("", "订单支付");
            // let { href } = this.$router.resolve({path:res.approval_url})
            // payUrl.location.href = href;
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 支付loading
     */
    payLoading() {
      let that = this;
      let loadingText =
        that.currLanguage == 3 ? "Payment in progress..." : this.pageTextArr[37]+"...";
      that.productPayloading = this.$loading({
        lock: true,
        text: loadingText,
        spinner: "el-icon-loading",
        customClass: "loadingclass",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },

    /**
     * 检测url参数
     */
    checkUrlParameter() {
      let that = this;
      let page_status = that.$route.query.page_status;
      if (page_status == 1) {
        return;
      } else {
        that.payLoading();
        let order_id = that.$route.query.order_id;
        let order_number = that.$route.query.order_number;
        let payment_id = that.$route.query.paymentId;
        let payer_id = that.$route.query.PayerID;
        let token = that.$route.query.token;
        if (payer_id != null) {
          // 成功支付查询
          that.successPay(order_id, order_number, payment_id, payer_id, token);
        } else if (payer_id == null && token != null) {
          // 失败支付查询
          that.cancelPay(order_id, order_number, token, payment_id);
        }
      }
    },

    /**
     * 成功支付查询
     */
    successPay(order_id, order_number, payment_id, payer_id, token) {
      let that = this;
      let data = {
        order_id: order_id, //订单id
        order_number: order_number, //编号
        payment_id: payment_id,
        payer_id: payer_id,
        token: token,
      };
      this.$http.successPay(
        data,
        (res) => {
          if (res.ret == 1) {
            // 关闭loading
            that.productPayloading.close();
            // 订单详情
            that.getUserOrderDetail();
            // 跳转支付成功页面
            this.$router.push({
              path: "/orderPaymentSucceeded",
              query: {
                order_number: order_number,
              },
            });
          } else {
            // 关闭loading
            that.productPayloading.close();
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // 关闭loading
          that.productPayloading.close();
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 取消支付查询
     */
    cancelPay(order_id, order_number, token, payment_id) {
      let that = this;
      let data = {
        order_id: order_id, //订单id
        order_number: order_number, //编号
        token: token,
        payment_id: payment_id,
      };
      this.$http.cancelPay(
        data,
        (res) => {
          if (res.ret == 1) {
            // 关闭loading
            that.productPayloading.close();
            // 订单详情
            that.getUserOrderDetail();
          } else {
            // 关闭loading
            that.productPayloading.close();
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // 关闭loading
          that.productPayloading.close();
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 跳转个人中心
     */
    toPersonCenter(index) {
      if (index == 0) {
        this.$router.push({
          path: "/",
        });
      } else {
        this.$router.push({
          path: "/personalCenter",
        });
      }
    },

    /**
     *  订单-取消订单-确认收货
     */
    dealOrder(order_id, status) {
      let that = this;
      let data = {
        order_id: order_id, //订单id
        status: status, //状态 -1取消 5确认收货
      };
      this.$http.dealOrder(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(res.msg);
            // 刷新我的订单
            that.getUserOrderDetail();
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr,type){
      let that = this
      let newpagetextArr = []
      if(type==1){
        that.translateByArr(arr,res=>{
        res.data.forEach((item,index)=>{
          newpagetextArr.push(item.translation)
        })
        that.pageTextArr = newpagetextArr
      })
      }else if (type==2){
        let newarr=[];
        arr.forEach((item,index)=>{
          newarr.push(item.title)
        })
        that.translateByArr(newarr,res=>{
        res.data.forEach((item,index)=>{
          that.waitingPayment.stepsData[index].title=item.translation
          })
        })
      }else{
        let newarr=[];
        let skuarr=[];
        arr.forEach((item,index)=>{
          newarr.push(item.title)
          skuarr.push(item.specifications)
        })
        that.translateByArr(newarr,res=>{
          res.data.forEach((item,index)=>{
          that.productInfo[index].title=item.translation
          })
        })
        that.translateByArr(skuarr,res=>{
          res.data.forEach((item,index)=>{
          that.productInfo[index].specifications=item.translation
          })
        })
      }
      
    }

  },
  mounted() {
    let that = this;
    // 当前语言
    that.currLanguage = localStorage.getItem("curLanguageType");
    //订单id
    that.order_id = that.$route.query.order_id;
    // 订单编号
    that.order_number = that.$route.query.order_number;
    // 当前时间
    this.getTime();
    // 订单详情
    that.getUserOrderDetail();
    // 支付结果查询
    that.checkUrlParameter();
    that.languageTranslateByArrs(that.pageTextArr,1)
    that.languageTranslateByArrs(that.waitingPayment.stepsData,2)
    // 选中产品菜单
    // that.$refs.headerMenuModular.activeIndex = 6;
  },
};
</script>


// WEBPACK FOOTER //
// src/view/waitingPayment.vue